























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { HOST, API_URL } from '../global';
import axios from 'axios';
import { swiper, swiperSlide, EffectFade } from 'vue-awesome-swiper';

@Component({
	name: 'HomeSlider',
	components: {
		swiper,
		swiperSlide,
		EffectFade,
	},
})
export default class HomeSlider extends Vue {
	@Prop() readonly compData!: any;
	isAutoplay: boolean = false;

	public HOST: string = HOST;
	tabdata: any[] = [];
	public swiperOption: any = {
		slidesPerView: 1,
		centeredSlides: false,
		grabCursor: false,
		loop: true,
		navigation: false,
		pagination: {
			el: '#slide-pagination',
			clickable: true,
		},
		effect: 'fade',
		fadeEffect: { crossFade: true },
		speed: 1500,
		autoplay: {

			delay: 4000,

		},
		onInit: function(s: any) {
			console.log('bbbbb');
		},

		//  onSlideChangeStart: function (s) {
		//             var currentSlide = $(s.slides[s.activeIndex]);
		//             currentSlide.find('#swipeLeft').removeClass('animated slideInLeft');
		//             currentSlide.find('#swipeRight').removeClass('animated slideInRight');

		//         },
		//         onSlideChangeEnd: function (s) {
		//             var currentSlide = $(s.slides[s.activeIndex]);
		//             currentSlide.find('#swipeLeft').addClass('animated slideInLeft');
		//             currentSlide.find('#swipeRight').addClass('animated slideInRight');
		//         }
	};
	public changeSwiperIndex() {
		console.log('aaa');
		(this as any).$refs.carousel.swiper.stopAutoplay();
		// if ((this as any).$refs.carousel.$swiper.activeIndex == 1) {
		//   (this as any).$refs.carousel.$swiper.stopAutoplay();
		//   setTimeout(() => {
		//       (this as any).$refs.carousel.$swiper.startAutoplay();
		//   }, 10000);
		// }
	}
	// public slides(){
	//    (this as any).$refs.carousel.swiper.stopAutoplay();

	// }
	created() {
		axios
			.get(`${API_URL}/pages/?&type=home.TabbedCollectionPage&fields=*`)
			.then((response) => {
				(this as any).tabdata = response.data;
			})
			.catch((e) => {
				(this as any).errors.push(e);
			});
	}
	mounted() {
		(this as any).$refs.carousel.swiper.autoplay.stop();
		setTimeout(() => {
			(this as any).isAutoplay = true;
			if (this.isAutoplay == true) {
				(this as any).$refs.carousel.swiper.autoplay.start();
			}

		}, 6000);

	}
}
